import React from 'react';
import clsx from 'clsx';

function Sidebar({ sidebarData, stepName, fullHeight = true, children, maxHeight = false }) {
    if (!sidebarData) return null;
    const sidebarStep = sidebarData.sidebarSteps.find((step) => step.step === stepName) || {};
    const { title, htmlText, sidebarLinks } = sidebarStep;
    const hasSidebarLinks = sidebarLinks?.length > 0;

    return (
        <div
            className={clsx(
                'sidebar',
                fullHeight && 'sidebar--full-height',
                maxHeight && 'sidebar--max-height',
            )}
        >
            <div className="sidebar__data">
                {title && <h3 className="sidebar__data-title">{title}</h3>}
                {htmlText && (
                    <div className="sidebar__data-html" dangerouslySetInnerHTML={{ __html: htmlText }} />
                )}
                {hasSidebarLinks && (
                    <div className="sidebar__data-links">
                        {sidebarLinks.map(({ target, href, title }) => (
                            <a className="button tertiary" target={target} href={href} key={title}>
                                {title}
                            </a>
                        ))}
                    </div>
                )}
            </div>

            {children}
        </div>
    );
}

export { Sidebar };
